import Vue from 'vue';

const defaultState = () => {
  return {
    categoryStates: {},
  };
};

const state = defaultState();

const getters = {
  categoryStates: state => state.categoryStates,
};

const mutations = {
  setCategoryStates(state, categoryStates) {
    if (!categoryStates || !Array.isArray(categoryStates)) {
      return;
    }
    let sortedStates = categoryStates.sort((a, b) => a.mobileCreatedAt - b.mobileCreatedAt);
    for (let categoryState of sortedStates) {
      Vue.set(state.categoryStates, categoryState.categoryId, categoryState);
    }
  },
  deleteCategoryStates(state, categoryId) {
    Vue.delete(state.categoryStates, categoryId);
  },
  reset(state) {
    Object.assign(state, defaultState());
  },
};

const actions = {
  fetchCategoryStates({ dispatch, commit, getters, rootGetters }) {
    return rootGetters['session/ajax'].get('/category_states').then(response => {
      if (response.data.records) {
        commit('setCategoryStates', response.data.records);
      } else {
        commit('setCategoryStates', response.data.categoryStates);
      }
    });
  },
  sendCategoryState({ dispatch, commit, getters, rootGetters }, params) {
    commit('setCategoryStates', [params]);
    return rootGetters['session/ajax'].post('/category_states', params).then(response => {
      return response;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
